'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _paths = require('ifeis-isomorphic/lib/redux/actions/events/paths');

var _paths2 = require('ifeis-isomorphic/lib/redux/actions/stages/paths');

var loading = { loading: true };

exports.default = function (feis_id) {
  return function (state) {
    // check for synchronization error
    if ((0, _paths2.stageEventsError)(state)) {
      return { error: true };
    }

    // can't do anything before we have stages or events
    if ((0, _paths2.stagesAreLoading)(state, feis_id) || (0, _paths.eventsAreLoading)(state, feis_id)) {
      return loading;
    }

    var stages = (0, _paths2.getStages)(state, feis_id);

    // we choose to not do anything before we have stages' events
    if (stages.find(function (id) {
      return (0, _paths2.stageEventsAreLoading)(state, id);
    })) {
      return loading;
    }

    // create a map of events by stage ID
    var eventsByStage = stages.reduce(function (m, stage_id) {
      var events = (0, _paths2.getEventsOnStage)(state, stage_id).map(function (ev) {
        return (0, _paths.getEvent)(state, ev.get('id')).merge(ev);
      });

      return m.set(stage_id, events);
    }, (0, _immutable.Map)());

    // we really care about the whole stage; not just the id
    stages = stages.map(function (id) {
      return (0, _paths2.getStage)(state, id);
    });

    var stagesByDay = stages.reduce(function (m, s) {
      var dt = s.get('dt');
      var day = m.get(dt) || (0, _immutable.List)();

      return m.set(dt, day.push(s));
    }, (0, _immutable.Map)());

    var unscheduledEvents = ((0, _paths2.getEventsUnscheduled)(state, feis_id) || (0, _immutable.List)()).map(function (ev) {
      return (0, _paths.getEvent)(state, ev.get('id')).merge(ev);
    });

    return {
      loading: false,

      stages: stages,
      stagesByDay: stagesByDay,
      eventsByStage: eventsByStage,
      unscheduledEvents: unscheduledEvents
    };
  };
};


//////////////////
// WEBPACK FOOTER
// ./util/mapStateToStageSchedule.js
// module id = 223
// module chunks = 0